import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            探索视频分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            八大精选分类，涵盖热门影视、综艺娱乐、动漫游戏等多种内容，总有一类适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-accent-100 rounded-lg mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-accent-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}